<div class="add_carrier_depot">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <ngx-loading [show]="isLoading"></ngx-loading>

  <div class="page_header">
    <h1>
      <!-- <ng-container *ngIf="!depotId"> ADD DEPOT </ng-container>
      <ng-container *ngIf="depotId"> UPDATE DEPOT </ng-container> -->
    </h1>
  </div>

  <div class="carrier_details">
    <h2>Carrier Details</h2>
    <div class="detail_row">
      <div class="column">Carrier ID:</div>
      <div class="column">{{ carrierId }}</div>
    </div>
    <!-- <div class="detail_row">
      <div class="column">Carrier Name:</div>
      <div class="column">{{carrierDetails.first_name}} {{carrierDetails.last_name}}</div>
    </div> -->
    <div class="detail_row">
      <div class="column">Company registered name:</div>
      <div class="column">{{ carrierDetails.registered_name }}</div>
    </div>
    <div class="detail_row">
      <div class="column">Company registered number:</div>
      <div class="column">{{ carrierDetails.registration_number }}</div>
    </div>
    <div class="detail_row">
      <div class="column">Trading name:</div>
      <div class="column">{{ carrierDetails.trading_name }}</div>
    </div>
    <div class="detail_row">
      <div class="column">Type of carrier:</div>
      <div class="column">{{carrierDetails.freight_passenger_ind |carrierType }}</div>
    </div>
    <div class="detail_row">
      <div class="column">Email Address:</div>
      <div class="column">{{ carrierDetails.email }}</div>
    </div>
    <div class="detail_row">
      <div class="column">Telephone:</div>
      <div class="column">
        {{ carrierDetails.dial_code_tele }} {{ carrierDetails.telephone }}
      </div>
    </div>
    <div class="detail_row">
      <div class="column">Cellphone:</div>
      <div class="column">
        {{ carrierDetails.dial_code_cell }} {{ carrierDetails.cellphone }}
      </div>
    </div>
  </div>

  <form class="form" id="DepotForm" [formGroup]="depotForm">
    <h2>Depot info</h2>
    <div class="row form_flex_row">
      <div class="col-12 col-md-6 form_field" *ngIf="branches.length > 0" style="display: none">
        <label class="label" for="carrier_id">Carrier ID <a class="red-asterik">*</a></label>
        <input type="number" (keypress)="numbersOnly($event)" id="carrier_id" class="form-control"
          formControlName="carrier_id" placeholder="Carrier ID" />
        <div *ngIf="
            depotForm.controls.carrier_id.invalid &&
            (depotForm.controls.carrier_id.touched ||
              depotForm.controls.carrier_id.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.carrier_id | validate : "carrier ID" }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field" *ngIf="branches.length > 0">
        <label class="label" for="branch">Branch <a class="red-asterik">*</a></label>
        <select name="branch" id="branch" formControlName="branch_carrier_id" class="form-control">
          <option selected hidden disabled>Select Branch</option>
          <ng-container *ngFor="let branch of branches">
            <option [value]="branch.id">{{ branch.account_name }}</option>
          </ng-container>
        </select>
        <div *ngIf="
            depotForm.controls.branch_carrier_id.invalid &&
            (depotForm.controls.branch_carrier_id.touched ||
              depotForm.controls.branch_carrier_id.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{
          depotForm.controls.branch_carrier_id
          | validate : "Branch Carrier ID"
          }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="depot_type">Depot Type <a class="red-asterik">*</a></label>
        <select name="depot_type" id="depot_type" formControlName="depot_type" class="form-control" required>
          <option selected hidden disabled>Select Depot Type</option>
          <ng-container *ngFor="let type of depotTypes">
            <option [value]="type.key">{{ type.value }}</option>
          </ng-container>
        </select>

        <div *ngIf="
            depotForm.controls.depot_type.invalid &&
            (depotForm.controls.depot_type.touched ||
              depotForm.controls.depot_type.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.depot_type | validate : "Depot Type" }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="name">Depot Name<a class="red-asterik">*</a></label>
        <input type="text" id="name" formControlName="name" class="form-control" placeholder="Depot Name" />
        <div *ngIf="
            depotForm.controls.name.invalid &&
            (depotForm.controls.name.touched || depotForm.controls.name.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.name | validate : "Name" }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="no_of_vehicles">No of vehicles <a class="red-asterik">*</a></label>
        <input type="text" id="no_of_vehicles" formControlName="number_of_vehicles" class="form-control"
          placeholder="No. of vehicles" />
        <div *ngIf="
            depotForm.controls.number_of_vehicles.invalid &&
            (depotForm.controls.number_of_vehicles.touched ||
              depotForm.controls.number_of_vehicles.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{
          depotForm.controls.number_of_vehicles
          | validate : "Number of Vehicles"
          }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="telephone">Telephone<a class="red-asterik">*</a></label>
        <ngx-intl-tel-input [cssClass]="'form-control input-sm'"
          [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
          [searchCountryFlag]="true" [searchCountryField]="[
            SearchCountryField.Iso2,
            SearchCountryField.Name
          ]" [selectFirstCountry]="false" [maxLength]="15" [tooltipField]="TooltipLabel.Name" [phoneValidation]="true"
          [selectedCountryISO]="defaultCountry" [separateDialCode]="separateDialCode"
          (countryChange)="ChangeCountry($event)" name="Telephone" formControlName="telephone" #MobileNumber
          (keyup)="validatePhone(depotForm.value.telephone)">
        </ngx-intl-tel-input>
        <div class="form-control-feedback text-danger text-small"
        *ngIf="depotForm.controls.telephone.invalid && depotForm.controls.telephone.dirty  && depotForm.controls.telephone.touched">
        <p>Invalid Telephone Number</p>
    </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="address">Address<a class="red-asterik">*</a></label>
        <input #physicalAddressInput (keyup)="onPhysicalAddressChange(physicalAddressInput)"
          (focus)="physicalAddressFocus()" (blur)="physicalAddressBlur()" autocomplete="new-Contact_PhysicalAddress1"
          formControlName="physical_address_1" class="form-control form-control-sm" type="text" [ngClass]="{
            error:
              depotForm.controls.physical_address_1.invalid &&
              depotForm.controls.physical_address_1.dirty,
            noerror:
              depotForm.controls.physical_address_1.valid &&
              depotForm.controls.physical_address_1.dirty
          }" />
        <div *ngIf="
            depotForm.controls.physical_address_1.invalid &&
            (depotForm.controls.physical_address_1.touched ||
              depotForm.controls.physical_address_1.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.physical_address_1 | validate : "Address" }}
        </div>
        <div *ngIf="isPlacesPredictionVible" class="search-dropdown-content">
          <div *ngFor="let place of placesPredictions" class="text-ellipsis" style="width: 100%">
            <div (click)="clickSearchedPlace(place, 'physical_address_1')" style="z-index: 2">
              <i class="fa fa-map-marker map-icon" style="font-size: 14px; margin-right: 5px"></i>{{ place.description
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="town">Town<a class="red-asterik">*</a></label>
        <input type="text" id="town" formControlName="physical_address_town" class="form-control" placeholder="Town" />
        <div *ngIf="
            depotForm.controls.physical_address_town.invalid &&
            (depotForm.controls.physical_address_town.touched ||
              depotForm.controls.physical_address_town.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.physical_address_town | validate : "town" }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="post_code">Post Code<a class="red-asterik">*</a></label>
        <input type="text" id="post_code" formControlName="physical_post_code" class="form-control"
          placeholder="Post Code" />
        <div *ngIf="
            depotForm.controls.physical_post_code.invalid &&
            (depotForm.controls.physical_post_code.touched ||
              depotForm.controls.physical_post_code.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.physical_post_code | validate : "Post Code" }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="country_id">Country<a class="red-asterik">*</a></label>
        <select class="form-control" id="country_id" name="country_id" formControlName="physical_place_id" [ngClass]="{
            error:
              depotForm.controls.physical_place_id.invalid &&
             depotForm.controls.physical_place_id.touched,
            noerror:
              depotForm.controls.physical_place_id.valid &&
              depotForm.controls.physical_place_id.dirty
          }" title="Country">
          <option value="" disabled selected>Select country</option>
          <option *ngFor="let country of ddlCountries" [ngValue]="country.id">
            {{ country.desc }}
          </option>
        </select>

        <div *ngIf="
            depotForm.controls.physical_place_id.invalid &&
            depotForm.controls.physical_place_id.touched 
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.physical_place_id | validate : "Country" }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="notes">Notes</label>
        <textarea name="notes" id="notes" formControlName="notes" class="form-control textarea" rows="8"></textarea>
      </div>
    </div>

    <!-- RCP Form -->
    <h2>Responsible Competent Person</h2>
    <div class="row form_flex_row">
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="id_type">ID Type<a class="red-asterik">*</a></label>
        <select name="id_type" id="id_type" formControlName="id_type_ind" class="form-control" (change)="idChange()">
          <option selected hidden disabled>Select ID Type</option>
          <ng-container *ngFor="let type of idTypes">
            <option [value]="type.key">{{ type.value }}</option>
          </ng-container>
        </select>
        <div *ngIf="
            depotForm.controls.id_type_ind.invalid &&
            (depotForm.controls.id_type_ind.touched ||
              depotForm.controls.id_type_ind.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.id_type_ind | validate : "ID Type" }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field" *ngIf="depotForm.controls.id_type_ind.value == 2">
        <label class="label" for="passport_country_id">Passport Country <a class="red-asterik">*</a></label>
        <select class="form-control" id="passport_country_id" name="passport_country_id"
          formControlName="passport_country_id" title="Country">
          <option value="" disabled selected>Select country</option>
          <option *ngFor="let country of ddlCountries" [ngValue]="country.id">
            {{ country.desc }}
          </option>
        </select>
        <div *ngIf="
            depotForm.controls.passport_country_id.invalid &&
            (depotForm.controls.passport_country_id.touched ||
              depotForm.controls.passport_country_id.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{
          depotForm.controls.passport_country_id
          | validate : "Passport Country"
          }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field" *ngIf="depotForm.controls.id_type_ind.value == 2">
        <label class="label" for="passport_number">Passport Number<a class="red-asterik">*</a></label>
        <input type="text" id="passport_number" formControlName="passport_number" class="form-control"
          placeholder="Passport Number" />
        <div *ngIf="
            depotForm.controls.passport_number.invalid &&
            (depotForm.controls.passport_number.touched ||
              depotForm.controls.passport_number.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{
          depotForm.controls.passport_number | validate : "Passport Number"
          }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field" *ngIf="!(depotForm.controls.id_type_ind.value == 2)">
        <label class="label" for="passport_number">ID Number<a class="red-asterik">*</a></label>
        <input type="text" id="id_number" formControlName="id_number" class="form-control"  (blur)="getHomeAffairsCarrierDetails()"
          (keypress)="numbersOnly($event)" placeholder="ID Number" maxlength="13" />
        <div *ngIf="
            depotForm.controls.id_number.invalid &&
            (depotForm.controls.id_number.touched ||
              depotForm.controls.id_number.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          <p *ngIf="depotForm.controls.id_number.errors.required"
            class="form-control-feedback text-danger text-small text-red pt-3">
            * ID Number is required
          </p>

          <p *ngIf="depotForm.controls.id_number.errors.invalid_id"
            class="form-control-feedback text-danger text-small text-red pt-3">
            * Invalid ID Number
          </p>

        </div>
      </div>
      <!-- <div class="col-12 col-md-6 form_field" *ngIf="depotForm.controls.id_type_ind.value == 2">
        <label class="label" for="passport_expiry_date">Passport Expiry Date<a class="red-asterik">*</a></label>
        <div class="input-group">
          <input #passportExpiration="ngbDatepicker" [minDate]="currentDate"
            (ngModelChange)="(passport_expiry_date == $event)" [ngModel]="passport_expiry_date" type="text"
            [placement]="'top'" container="body" readonly id="passport_expiry_date"
            (click)="passportExpiration.toggle()" formControlName="passport_expiry_date" class="form-control"
            placeholder="Passport Expiry date" ngbDatepicker />
          <div class="input-group-append">
            <span class="input-group-text">
              <i class="fa fa-calendar" (click)="passportExpiration.toggle()"></i>
            </span>
          </div>
        </div>
        <div *ngIf="
            depotdepotForm.controls.passport_expiry_date.invalid &&
            (depotdepotForm.controls.passport_expiry_date.touched ||
              depotdepotForm.controls.passport_expiry_date.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{
          depotdepotForm.controls.passport_expiry_date
          | validate : "Passport Expiry Date"
          }}
        </div>
      </div> -->

      <div class="col-12 col-md-6 form_field" *ngIf="depotForm.controls.id_type_ind.value == 2">
        <label class="label" for="passport_expiry_date">Passport Expiry Date<a class="red-asterik">*</a></label>
    
        <input type="text" [minDate]="currentDate"
            value="{{ passport_expiry_date | date:'dd/MM/yyyy' }}" [placement]="'top'" container="body"
            ngbDatepicker #passportExpiryDatePicker="ngbDatepicker" (click)="passportExpiryDatePicker.toggle()"
            style="z-index: 9999 !important;" name="passport_expiry_date" formControlName="passport_expiry_date"
            class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
            [ngClass]="{'error': depotForm.controls.passport_expiry_date.invalid && depotForm.controls.passport_expiry_date.dirty, 'noerror': depotForm.controls.passport_expiry_date.valid && depotForm.controls.passport_expiry_date.dirty}" />
        <!-- <i class="fa fa-calendar calendar-icon" (click)="passportExpiryDatePicker.toggle()"></i> -->
        <div class="form-control-feedback text-danger text-small"
            *ngIf="depotForm.controls.passport_expiry_date.invalid && depotForm.controls.passport_expiry_date.dirty">
            <p *ngIf="depotForm.controls.passport_expiry_date.errors.required">*Required</p>
        </div>
    </div>
    

      <div class="col-12 col-md-6 form_field">
        <label class="label" for="firstname">First Name<a class="red-asterik">*</a></label>
        <input type="text" id="firstname" formControlName="first_name" class="form-control" placeholder="First Name" [readOnly]="homeaffairsReadOnly" (keypress)="letterOnly($event)"/>
        <div *ngIf="
            depotForm.controls.first_name.invalid &&
            depotForm.controls.first_name.touched
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.first_name | validate : "first name" }}
          <!-- <p *ngIf="depotForm.controls.first_name.errors.required">
            * Required
          </p> -->
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="lastname">Last Name<a class="red-asterik">*</a></label>
        <input type="text" id="lastname" formControlName="last_name" class="form-control" placeholder="Last Name" [readOnly]="homeaffairsReadOnly" (keypress)="letterOnly($event)"/>
        <div *ngIf="
            depotForm.controls.last_name.invalid &&
            (depotForm.controls.last_name.touched ||
              depotForm.controls.last_name.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.last_name | validate : "last name" }}
        </div>
      </div>
      <!-- <div class="col-12 col-md-6 form_field">
        <label class="label" for="dob">Date of Birth <a class="red-asterik">*</a></label>
        <div class="input-group">
          <input #date_of_birth="ngbDatepicker" type="text" id="dob" [placement]="'top'" container="body" readonly [disabled]="homeaffairsReadOnly"
            id="date_of_birth" (click)="date_of_birth.toggle()" formControlName="date_of_birth" class="form-control"
            placeholder="Date of Birth" ngbDatepicker value="{{ dob | date:'dd/MM/yyyy' }}" [minDate]="{year: 1900, month:1, day: 1}" [maxDate]="getMaxDate()" />
          <div class="input-group-append">
            <span class="input-group-text">
              <i class="fa fa-calendar" (click)="date_of_birth.toggle()"></i>
            </span>
          </div>
        </div>
        <div *ngIf="
            depotForm.controls.date_of_birth.invalid &&
            (depotForm.controls.date_of_birth.touched ||
              depotForm.controls.date_of_birth.dirty)
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.date_of_birth | validate : "Date Of Birth" }}
        </div>
      </div> -->

      <div class="col-12 col-md-6 form_field">
        <label class="label" for="dob">Date of Birth <a class="red-asterik">*</a></label>
    
        <input type="text" [minDate]="{year: 1900, month:1, day: 1}" [maxDate]="getMaxDate()"
        value="{{ date_of_birth | date:'dd/MM/yyyy' }}" [placement]="'top'" container="body"readonly
            ngbDatepicker #dobDatePicker="ngbDatepicker" (click)="dobDatePicker.toggle()"
            style="z-index: 9999 !important;" name="date_of_birth" formControlName="date_of_birth"
            class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
            [ngClass]="{'error': depotForm.controls.date_of_birth.invalid && depotForm.controls.date_of_birth.dirty, 'noerror': depotForm.controls.date_of_birth.valid && depotForm.controls.date_of_birth.dirty}" />
        <!-- <i class="fa fa-calendar calendar-icon" (click)="dobDatePicker.toggle()"></i> -->
        <div class="form-control-feedback text-danger text-small"
            *ngIf="depotForm.controls.date_of_birth.invalid && depotForm.controls.date_of_birth.dirty">
            <p *ngIf="depotForm.controls.date_of_birth.errors.required">*Required</p>
        </div>
    </div>
    

      <div class="col-12 col-md-6 form_field">
        <label class="label" for="id_type">Gender <a class="red-asterik">*</a></label>
        <select name="id_type" id="id_type" formControlName="gender" class="form-control" [disabled]="homeaffairsReadOnly">
          <option selected hidden disabled>Select Gender</option>
          <ng-container *ngFor="let type of genderTypes">
            <option [value]="type.key" [disabled]="homeaffairsReadOnly" >{{ type.value }}</option>
          </ng-container>
        </select>
        <div *ngIf="
            depotForm.controls.gender.invalid &&
            (depotForm.controls.gender.dirty ||
              depotForm.controls.gender.touched)
          " class="form-control-feedback text-danger text-small text-red">
          {{ depotForm.controls.gender | validate : "gender" }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="cellphone">Cellphone <a class="red-asterik">*</a></label>
        <ngx-intl-tel-input [cssClass]="'input-bold no_border'"
         [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
         [enablePlaceholder]="true" [searchCountryFlag]="true"
         [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
         [selectFirstCountry]="false" [maxLength]="15" [tooltipField]="TooltipLabel.Name"
         [phoneValidation]="true" [selectedCountryISO]="defaultCountry"
         [separateDialCode]="separateDialCode" (countryChange)="ChangeCountry($event)"
         name="cellphone" formControlName="cellphone">
        </ngx-intl-tel-input>
         <div class="form-control-feedback text-danger text-small"
         *ngIf="depotForm.controls.cellphone.invalid && depotForm.controls.cellphone.touched">
            <p>Invalid Cellphone Number</p>
          </div>
        

      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="email">Email <a class="red-asterik">*</a></label>
        <input type="email" id="email" formControlName="email" class="form-control" placeholder="Email" [ngClass]="{
            error:
              depotForm.controls.email.invalid &&
              depotForm.controls.email.dirty,
            noerror:
              depotForm.controls.email.valid && depotForm.controls.email.dirty
          }" />
        <div class="form-control-feedback text-danger text-small text-red" *ngIf="
            depotForm.controls.email.invalid &&
            (depotForm.controls.email.dirty || depotForm.controls.email.touched)
          ">
          {{ depotForm.controls.email | validate : "email" }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="qualification">Qualification <a class="red-asterik">*</a></label>
        <select type="text" id="qualification" formControlName="qualification" class="form-control"
          placeholder="Qualification" maxlength="50">
        <option value="Grade 12">Grade 12</option>
        <option value="Degree">Transport related Degree or diploma</option>
        <option value="Experience">Experience (related in Transport industry)</option>
        </select>
        <div class="form-control-feedback text-danger text-small text-red" *ngIf="
            depotForm.controls.qualification.invalid &&
            (depotForm.controls.qualification.dirty || depotForm.controls.qualification.touched)
          ">
          {{ depotForm.controls.qualification | validate : "qualification" }}
        </div>
      </div>
      <div class="col-12 col-md-6 form_field">
        <label class="label" for="experience">Experience <a class="red-asterik">*</a></label>
        <input type="number" id="experience" formControlName="experience" class="form-control" placeholder="Experience"
          [ngClass]="{
            error:
              depotForm.controls.experience.invalid &&
              depotForm.controls.experience.dirty,
            noerror:
              depotForm.controls.experience.valid && depotForm.controls.experience.dirty
          }" />
        <div class="form-control-feedback text-danger text-small text-red" *ngIf="
            depotForm.controls.experience.invalid &&
            (depotForm.controls.experience.dirty || depotForm.controls.experience.touched)
          ">
          {{ depotForm.controls.experience | validate : "experience" }}
        </div>
      </div>


      <!-- This is the end of the form -->


      <div class="col-12 col-md-6 form_field" style="display: none">
        <label class="label" for="physical_address">Physical Address</label>
        <!-- <input
          type="text"
          id="physical_address"
          formControlName="physical_address_2"
          class="form-control"
          placeholder="Physical Address"
        /> -->
        <input #physicalAddressInput1 (keyup)="onPhysicalAddressChange(physicalAddressInput)"
          (focus)="physicalAddressFocus()" (blur)="physicalAddressBlur()" autocomplete="new-Contact_PhysicalAddress1"
          formControlName="physical_address_2" class="form-control form-control-sm" type="text" />
        <div *ngIf="isPlacesPredictionVible" class="search-dropdown-content" style="display: none">
          <div *ngFor="let place of placesPredictions" class="text-ellipsis" style="width: 100%">
            <div (click)="clickSearchedPlace(place, 'physical_address_2')" style="z-index: 2">
              <i class="fa fa-map-marker map-icon" style="font-size: 14px; margin-right: 5px"></i>{{ place.description
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 form_field" style="display: none">
        <label class="label" for="town_name">Town</label>
        <input type="text" id="town_name" class="form-control" placeholder="Town" />
      </div>
      <div class="col-12 col-md-6 form_field" style="display: none">
        <label class="label" for="postal_code">Post Code</label>
        <input type="text" id="postal_code" class="form-control" placeholder="Post Code" />
      </div>
      <div class="col-12 col-md-6 form_field" style="display: none">
        <label class="label" for="country">Country</label>
        <select class="form-control" id="country_id" name="country_id" title="Country">
          <!-- [ngClass]="{
            error:
              depotForm.controls.physical_place_id.invalid &&
              depotForm.controls.physical_place_id.dirty,
            noerror:
              depotForm.controls.physical_place_id.valid &&
              depotForm.controls.physical_place_id.dirty
          }" -->
          <option value="" disabled selected>Select country</option>
          <option *ngFor="let country of ddlCountries" [ngValue]="country.id">
            {{ country.desc }}
          </option>
        </select>
      </div>
    </div>

    <div class="card border-light shadow-sm" style="background-color: #f5f8ff !important">
      <div class="contact-details opensans-semi-bold-sapphire-30px">
        <span class="opensans-semi-bold-sapphire-30px">RCP Document Uploads</span>
      </div>
      <div class="rectangle-34"></div>
      <span class="opensans-semi-bold-black-16px-2">Please ensure documents being submitted are clear and
        visible, any document that is not clear and visible will be
        rejected.</span>
      <span class="opensans-semi-bold-black-16px-2">All foreign documents must be translated by a certified
        translator into English.</span>

      <div class="row m-0">
        <table style="width: 100%">
          <ng-container *ngFor="let UserDocument of uploadedDocs; let i = index">
            <tr>
              <td>
                <div class="contact-details opensans-bold-sapphire-20px">
                  <span class="opensans-bold-sapphire-20px">{{
                    UserDocument.description
                    }}</span>
                </div>
                <div class="rectangle-34"></div>
                <br />
                <div>
                  <!-- {{filename}} -->
                </div>
                <label class="dropzone" fileDragDrop (filesChangeEmiter)="
                            onFileChange($event, UserDocument.id)
                            ">
                  <div class="text-wrapper">
                    <div class="centered">
                      <img src="/assets/upload_icon.png" style="width: 21.33px" />
                      <input id="fileuploads{{ UserDocument.id }}" #fileuploads{{UserDocument.id}} type="file"
                        style="width: 100px" (change)="
                                  onFileSelected($event, UserDocument.id)
                                  " />
                      <br />
                      <label for="fileuploads{{ UserDocument.id }}"><span class="textLink">Drag and drop files here or
                          click to search
                          on your computer</span>
                        <br /><br />
                        <span style="
                                      text-decoration: underline;
                                      color: #274c9c;
                                    ">Upload file</span></label>
                    </div>
                  </div>
                </label>
              </td>
              <td></td>
              <td style="padding-right: 20px"></td>

              <td></td>
            </tr>
            <label><span class="txt-max">
                Max file size {{ maxMB }} PDF format.</span></label>
            <tr *ngFor="let Document of viewDocuments">
              <td *ngIf="UserDocument.id == Document.document_type_id">
                <div class="card">
                  <h5 class="card-title">Files Uploaded</h5>

                  <div class="card-body">
                    <!-- <h2>Files Uploaded(0)</h2> -->

                    <div class="row">
                      <div class="col-sm bg-light">
                        {{ Document.file_name }}
                      </div>
                      <div class="col-sm bg-light">PDF</div>
                      <div class="col-sm bg-light">
                        <span style="float: right !important">
                          <div class="file-upload-icons-group">
                            <a><img title="View Document" class="file-upload-icon" src="/assets/visibility.png"
                                alt="visibility" data-toggle="modal" data-target="#depotViewDoc" (click)="
                                viewDoc(
                                  Document.document_type_id,
                                  Document.document_link
                                            )
                                          " /></a>
                            <img title="Delete Document" class="file-upload-icon" (click)="onConfirm(Document)"
                              src="/assets/delete.png" alt="delete" />
                          </div>
                          <!-- <span title="Upload another of the same type" *ngIf="UserDocument.multiple_allowed == true" class="btn btn-primary btn-sm"><i
                              class="fa fa-plus" aria-hidden="true" (click)="extraDoc(UserDocument)"></i></span> -->
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td></td>
            </tr>
          </ng-container>

          <tr *ngIf="uploadedDocs?.length == 0">
            <td>No Documents found</td>
          </tr>
        </table>
      </div>
    </div>




    <div class="action_btns">
      <div class="btn_wrap">
        <button type="button" (click)="back()" class="btn btn_secondary">
          Back
        </button>
      </div>
      <div class="btn_wrap">
        <button type="submit" (click)="submitForm()" class="btn btn_primary">
          Save
        </button>
      </div>
    </div>
  </form>
</div>




<div
  class="modal fade"
  id="depotViewDoc"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
<div class="modal-dialog modal-lg" tabindex="-1" aria-hidden="true" role="document">
  <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Depot Document View</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
      </div>
      <div class="modal-body modal-lg">
        <div style="width: 99%; min-height: 470px">
          <pdf-viewer
            *ngIf="pdfSrc"
            [src]="pdfSrc"
            [render-text]="true"
            style="display: block"
            [original-size]="false"
            [autoresize]="true"
          ></pdf-viewer>
          <img [src]="img" *ngIf="img" />
          <ngx-loading [show]="isLoading"></ngx-loading>
        </div>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn pull-right btn_secondary" data-dismiss="modal">Close</button>
           <!-- <button type="button" class="btn btn-primary">Save changes</button>  -->
</div>
</div>
</div>
</div>
